export function gsapMarquee(_sel) {
    // set a default rate, the higher the value, the faster it is
    const rate = 100;
    // get the width of the element
    const distance = _sel.clientWidth;
    // get the margin-right of the element
    const style = window.getComputedStyle(_sel);
    const marginRight = parseInt(style.marginRight) || 0;
    // get the total width of the element
    const totalDistance = distance + marginRight;
    // get the duration of the animation
    // for a better explanation, see the quoted codepen in the first comment
    const time = totalDistance / rate;
    // get the parent of the element
    const container = _sel.parentElement;

    container.appendChild(_sel.cloneNode(true));
    container.appendChild(_sel.cloneNode(true));
    container.appendChild(_sel.cloneNode(true));
    container.appendChild(_sel.cloneNode(true));

    gsap.to(container, time, {
        repeat: -1,
        x: '-' + totalDistance,
        ease: Linear.easeNone
    });
}